export default __webpack_public_path__ + "static/media/DMK_Styleframes_01.0d766f01.jpg";